export default __webpack_public_path__ + "static/media/barlow-condensed.regular.0f2acd3e.ttf";